import {useSyncExternalStore} from 'react';
import {readSyncDiagnostics,subscribeSyncDiagnostics,type SyncPhase} from './sync-diagnostics';
const labels:Record<SyncPhase,string>={head:'餐單版本',checkpoint:'餐單資料',changes:'餐單更新',dynamic:'營運資料',session:'登入驗證',startup:'啟動確認'};
export function SyncDiagnostics(){
  const rows=useSyncExternalStore(subscribeSyncDiagnostics,readSyncDiagnostics,readSyncDiagnostics);
  if(!rows.length)return null;
  return <details className="panel" style={{overflowWrap:'anywhere'}}><summary>連線診斷</summary><p>只記錄請求階段、狀態及時間，唔包含登入密鑰或客人資料。</p><ol>{rows.map((row,index)=><li key={index}>{labels[row.phase]} · {row.status===null?'未收到回覆':'HTTP '+row.status} · {row.code} · {row.elapsedMs}ms</li>)}</ol></details>;
}
